<div *ngIf="featuredProduct && !suggestedProduct.productDetails?.length">
    <div *ngIf="screenWidth === 'XL'" class="featured-container-xl">
        <div kuiText class="call-out">
            {{ "featured" | translate }}
        </div>
        <div class="product-container clearfix">
            <div class="img-col-xl">
                <div class="image-xl">
                    <kui-image aspectRatio="1-1">
                        <img #fim title="{{ featuredProduct.productVariationName }}"
                            alt="{{ featuredProduct.productVariationName }}" src="{{ featuredProduct.imageUrl }}"
                            data-alt="Featured product" class="featured-img" (window:resize)="createThumbnail(fim)"
                            (load)="createThumbnail(fim)" (error)="showImgError(fim)" />
                    </kui-image>
                </div>
            </div>
            <div class="details-col">
                <h2 kuiText class="name h--smallest" id="pt-{{ featuredProduct.productId }}">
                    {{ featuredProduct.productVariationName }}
                </h2>
                <div class="specs-container">
                    <ul>
                        <li *ngFor="let specs of featuredProduct.productInfo">
                            <div kuiText class="specs p-medium">
                                {{ specs.name | translate }}: {{ specs.value | translate }}
                            </div>
                        </li>
                    </ul>

                    <popover id="42" *ngIf="
                  featuredProduct.hasStsOffer &&
                  checkOfferType(featuredProduct.stsOfferTxt, 'a_o')
                " [screenwidth]="screenWidth" [type]="'a_o'"
                        [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'a_o')"></popover>
                    <popover id="43" *ngIf="checkOfferType(featuredProduct.stsOfferTxt, 'e_s')"
                        [screenwidth]="screenWidth" [type]="'e_s'"
                        [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'e_s')"></popover>
                    <popover id="44" *ngIf="
                  featuredProduct.hasStsOffer &&
                  checkOfferType(featuredProduct.stsOfferTxt, 'g_b')
                " [screenwidth]="screenWidth" [type]="'g_b'"
                        [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'g_b')"></popover>
                    <!-- popover id="42" *ngIf="featuredProduct.hasStsOffer" [screenwidth]="screenWidth" [type]="'e_s'" [bundle]="featuredProduct.stsOfferTxt"></popover -->
                    <popover id="46" *ngIf="featuredProduct.shipInfo" [screenwidth]="screenWidth"
                        [type]="'Availability'" [availability]="featuredProduct.shipInfo"></popover>
                </div>
                <div>
                    <a kuiText class="more-info">More Info</a>
                </div>
            </div>
            <div #drSpinnerCont class="buy-col-xl 49">
                <!-- [class.dr-spinner-bg]="featuredProduct.digitialRiverID" -->

                <div>
                    <!-- ngIf="featuredProduct.digitialRiverID" -->
                    <div class="price clearfix h--smallest" *ngIf="locale === 'ru-ru'">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{ featuredProduct.currencyCode
                            }}{{ featuredProduct.salePrice }}</span>
                    </div>
                    <div class="price clearfix h--smallest" *ngIf="locale !== 'ru-ru'">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{ featuredProduct.currencyCode
                            }}{{ getPriceIntegerDot(featuredProduct.salePrice) }}</span><span
                            *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="decimal">{{
                            getPriceDecimal(featuredProduct.salePrice) }}</span>
                    </div>
                    <div class="buy-box">
                        <!-- <span *ngIf="locale === 'en-us'" class="extra_style nv-buy-link" [attr.btn-type]='featuredProduct.prdStatus' style="visibility:hidden" [attr.data-mpn-code]="getEANCode(featuredProduct.sku)" data-color="#76b900" data-secondary-color="#fff" (click)="productName(featuredProduct)" >{{featuredProduct.prdStatus | translate }}</span> -->
                        <!-- <div *ngIf="locale !== 'en-us'" style="display: inline-block; text-align: center;" class="nv-buy-link" [attr.data-pid]="featuredProduct.productId" [attr.btn-type]="featuredProduct.prdStatus" (click)="showOverlay(featuredProduct)">{{featuredProduct.prdStatus | translate }}</div> -->

                        <span *ngIf="locale === 'en-us'" class="extra_style nv-buy-link"
                            [attr.btn-type]="featuredProduct.prdStatus" [attr.data-pid]="featuredProduct.productId"
                            style="visibility:hidden" [attr.data-mpn-code]="getEANCode(featuredProduct.sku)"
                            data-color="#76b900" data-secondary-color="#fff" (click)="productName(featuredProduct)">{{
                            featuredProduct.prdStatus | translate }}</span>
                        <span *ngIf="locale !== 'en-us'" class="extra_style nv-buy-link"
                            [attr.btn-type]="featuredProduct.prdStatus" [attr.data-pid]="featuredProduct.productId"
                            style="visibility:hidden" [attr.data-mpn-code]="getEANCode(featuredProduct.sku)"
                            data-color="#76b900" data-secondary-color="#fff" (click)="productName(featuredProduct)">{{
                            featuredProduct.prdStatus | translate }}</span>

                        <!-- input type="button" class="nv-buy-link" [attr.btn-type]='featuredProduct.prdStatus' value="{{featuredProduct.prdStatus| translate | uppercase}}" (click)="showOverlay(featuredProduct)" / -->
                    </div>
                </div>

                <div #drId *ngIf="featuredProduct.digitialRiverID === '4fs|~'" style="visibility:hidden; display: none"
                    class="featured product-row__item js-product-item" data-analytics="btn-dr-id"
                    [attr.data-digital-river-id]="
                changeDRId(featuredProduct.digitialRiverID)
              ">
                    <div #priceDiv class="price js-product-price clearfix "></div>
                    <div class="price  outside-page">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{
                            extractDRPriceIntegerDot(priceDiv, drSpinnerCont)
                            }}</span><span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="decimal">{{
                            extractDRPriceDecimal(priceDiv) }}</span>
                    </div>

                    <div class="buy cta-preorder mobile-top" (click)="transmitToCart()">
                        <a class="featured-buy-link link-btn brand-green cta-button show-out-of-stock"
                            href="javascript:void(0);">
                            {{ "add_to_cart" | translate }}
                        </a>
                    </div>

                    <div class="ship-date"></div>
                </div>
                <div *ngIf="featuredProduct.digitialRiverID === '4fs|~'">
                    <dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
                </div>
                <div>
                    <span kuiText [class.compare]="featuredProduct.addRemoveCompare === 'Compare'"
                        [class.remove]="featuredProduct.addRemoveCompare === 'Remove'" (click)="
                  compareProduct(
                    featuredProduct.upc,
                    featuredProduct.addRemoveCompare
                  )
                ">{{
                        featuredProduct.addRemoveCompare | lowercase | translate
                        }}</span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="screenWidth === 'MD' || screenWidth === 'LG'" class="featured-container-lg">
        <div class="call-out">
            {{ "featured" | translate }}
        </div>
        <div class="product-container clearfix">
            <div class="img-col-lg">
                <div class="image-lg">
                    <kui-image aspectRatio="1-1">
                        <img #fimlg title="{{ featuredProduct.productVariationName }}"
                            src="{{ featuredProduct.imageUrl }}" alt="{{ featuredProduct.productVariationName }}"
                            class="featured-img" (window:resize)="createThumbnail(fimlg)"
                            (load)="createThumbnail(fimlg)" (error)="showImgError(fimlg)" />
                    </kui-image>
                </div>
                <h2 kuiText class="name h--smallest" id="pt-{{ featuredProduct.productId }}">
                    {{ featuredProduct.productVariationName }}
                </h2>
                <div class="specs-container">
                    <ul>
                        <li *ngFor="let specs of featuredProduct.productInfo">
                            <div kuiText class="specs">
                                {{ specs.name | translate }}: {{ specs.value | translate }}
                            </div>
                        </li>
                    </ul>

                    <!-- popover id="110" *ngIf="featuredProduct.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="featuredProduct.stsOfferTxt"></popover -->
                    <popover id="114" *ngIf="
                  featuredProduct.hasStsOffer &&
                  checkOfferType(featuredProduct.stsOfferTxt, 'a_o')
                " [screenwidth]="screenWidth" [type]="'a_o'"
                        [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'a_o')"></popover>
                    <popover id="115" *ngIf="checkOfferType(featuredProduct.stsOfferTxt, 'e_s')"
                        [screenwidth]="screenWidth" [type]="'e_s'"
                        [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'e_s')"></popover>
                    <popover id="116" *ngIf="
                  featuredProduct.hasStsOffer &&
                  checkOfferType(featuredProduct.stsOfferTxt, 'g_b')
                " [screenwidth]="screenWidth" [type]="'g_b'"
                        [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'g_b')"></popover>
                    <popover id="117" *ngIf="featuredProduct.shipInfo" [screenwidth]="screenWidth"
                        [type]="'Availability'" [availability]="featuredProduct.shipInfo"></popover>
                </div>
                <div>
                    <a kuiText class="more-info">More Info</a>
                </div>
            </div>
            <div #drSpinnerCont class="buy-col-lg" [class.dr-spinner-bg]="featuredProduct.digitialRiverID">
                <div *ngIf="!featuredProduct.digitialRiverID">
                    <div class="price clearfix h--smallest" *ngIf="locale === 'ru-ru'">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{ featuredProduct.currencyCode
                            }}{{ featuredProduct.salePrice }}</span>
                    </div>
                    <div class="price clearfix h--smallest" *ngIf="locale !== 'ru-ru'">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{ featuredProduct.currencyCode
                            }}{{ getPriceIntegerDot(featuredProduct.salePrice) }}</span><span
                            *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="decimal">{{
                            getPriceDecimal(featuredProduct.salePrice) }}</span>
                    </div>
                    <div class="buy-box">
                        <span kuiText *ngIf="locale === 'en-us'" class="extra_style nv-buy-link"
                            [attr.data-pid]="featuredProduct.productId" [attr.btn-type]="featuredProduct.prdStatus"
                            [attr.data-mpn-code]="getEANCode(featuredProduct.sku)" data-color="#76b900"
                            data-secondary-color="#fff" (click)="productName(featuredProduct)">{{
                            featuredProduct.prdStatus | translate }}</span>
                        <span kuiText *ngIf="locale !== 'en-us'" class="extra_style nv-buy-link"
                            [attr.data-pid]="featuredProduct.productId" [attr.btn-type]="featuredProduct.prdStatus"
                            [attr.data-mpn-code]="getEANCode(featuredProduct.sku)" data-color="#76b900"
                            data-secondary-color="#fff" (click)="productName(featuredProduct)">{{
                            featuredProduct.prdStatus | translate }}</span>
                        <!--   <div *ngIf="locale !== 'en-us'" style="display: inline-block; text-align: center;" class="buy-link" (click)="showOverlay(featuredProduct)">{{featuredProduct.prdStatus | translate | uppercase}}</div>
                         input type="button" class="nv-buy-link" [attr.btn-type]="featuredProduct.prdStatus" value="{{featuredProduct.prdStatus | translate | uppercase}}" (click)="showOverlay(featuredProduct)" / -->
                    </div>
                </div>

                <div #drId *ngIf="featuredProduct.digitialRiverID === '4fs|~'" style="display:none; visibility: hidden"
                    class="featured product-row__item js-product-item" data-analytics="btn-dr-id"
                    [attr.data-digital-river-id]="
                changeDRId(featuredProduct.digitialRiverID)
              ">
                    <div #priceDivFeaturedMD class="price js-product-price clearfix"></div>
                    <div class="price clearfix h--smallest outside-page">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{
                            extractDRPriceIntegerDot(priceDivFeaturedMD, drSpinnerCont)
                            }}</span><span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="decimal">{{
                            extractDRPriceDecimal(priceDivFeaturedMD) }}</span>
                    </div>
                    <div kuiText class="buy cta-preorder mobile-top" (click)="transmitToCart()">
                        <a class="featured-buy-link link-btn brand-green cta-button show-out-of-stock"
                            href="javascript:void(0);">
                            {{ "add_to_cart" | translate }}
                        </a>
                    </div>
                    <div class="ship-date"></div>
                </div>
                <div *ngIf="featuredProduct.digitialRiverID === '4fs|~'">
                    <dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
                </div>

                <div>
                    <div>
                        <span kuiText [class.compare]="
                    featuredProduct.addRemoveCompare === 'Compare'
                  " [class.remove]="featuredProduct.addRemoveCompare === 'Remove'" (click)="
                    compareProduct(
                      featuredProduct.upc,
                      featuredProduct.addRemoveCompare
                    )
                  ">{{
                            featuredProduct.addRemoveCompare | lowercase | translate
                            }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="screenWidth === 'SM'" class="featured-container-sm">
        <div kuiText class="call-out">
            {{ "featured" | translate }}
        </div>
        <div class="product-container clearfix">
            <div class="image-sm">
                <kui-image aspectRatio="1-1">
                    <img #fimsm title="{{ featuredProduct.productVariationName }}" src="{{ featuredProduct.imageUrl }}"
                        alt="{{ featuredProduct.productVariationName }}" class="featured-img-sm"
                        (window:resize)="createThumbnail(fimsm)" (load)="createThumbnail(fimsm)"
                        (error)="showImgError(fimsm)" />
                </kui-image>
            </div>
            <h2 class="name h--smallest" id="pt-{{ featuredProduct.productId }}">
                {{ featuredProduct.productVariationName }}
            </h2>
            <div class="specs-container">
                <ul>
                    <li *ngFor="let specs of featuredProduct.productInfo">
                        <div kuiText class="specs p-medium">
                            {{ specs.name | translate }}: {{ specs.value | translate }}
                        </div>
                    </li>
                </ul>
            </div>
            <div #drSpinnerCont [class.dr-spinner-bg]="!featuredProduct.digitialRiverID">
                <div #drId *ngIf="featuredProduct.digitialRiverID" style="display: none; visibility: hidden"
                    class="featured product-row__item js-product-item" data-analytics="btn-dr-id"
                    [attr.data-digital-river-id]="
                changeDRId(featuredProduct.digitialRiverID)
              ">
                    <div #priceDivFeaturedSM class="price-sm price js-product-price clearfix"></div>
                    <div class="price  outside-page">
                        <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">{{
                            extractDRPriceIntegerDot(priceDivFeaturedSM, drSpinnerCont)
                            }}</span><span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="decimal">{{
                            extractDRPriceDecimal(priceDivFeaturedSM) }}</span>
                    </div>
                    <div class="buy cta-preorder mobile-top" (click)="transmitToCart()">
                        <a kuiText class="featured-buy-link link-btn brand-green cta-button show-out-of-stock"
                            href="javascript:void(0);">
                            {{ "add_to_cart" | translate }}
                        </a>
                    </div>
                    <div class="ship-date"></div>
                </div>
            </div>
            <div>
                <!-- ngIf="featuredProduct.digitialRiverID" -->
                <dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
            </div>

            <div>
                <!-- ngIf="featuredProduct.digitialRiverID" -->
                <div class="price clearfix h--smallest" *ngIf="locale === 'ru-ru'">
                    {{ featuredProduct.currencyCode }} {{ featuredProduct.salePrice }}
                </div>
                <div class="price clearfix h--smallest" *ngIf="locale !== 'ru-ru'">
                    <span *ngIf="featuredProduct.prdStatus != 'nv_notify_me'">
                        {{ featuredProduct.currencyCode }}
                        {{ getPriceIntegerDot(featuredProduct.salePrice) }}</span><span
                        *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="decimal">{{
                        getPriceDecimal(featuredProduct.salePrice) }}</span>
                </div>
                <div class="buy-box">
                    <span kuiText *ngIf="locale === 'en-us'" class="extra_style nv-buy-link"
                        [attr.data-pid]="featuredProduct.productId" [attr.btn-type]="featuredProduct.prdStatus"
                        [attr.data-mpn-code]="getEANCode(featuredProduct.sku)" data-color="#76b900"
                        data-secondary-color="#fff" (click)="productName(featuredProduct)">{{ featuredProduct.prdStatus
                        | translate }}</span>
                    <span kuiText *ngIf="locale !== 'en-us'" class="extra_style nv-buy-link"
                        [attr.data-pid]="featuredProduct.productId" [attr.btn-type]="featuredProduct.prdStatus"
                        [attr.data-mpn-code]="getEANCode(featuredProduct.sku)" data-color="#76b900"
                        data-secondary-color="#fff" (click)="productName(featuredProduct)">{{ featuredProduct.prdStatus
                        | translate }}</span>
                    <!--  <div *ngIf="locale !== 'en-us'" style="display: inline-block; text-align: center;" class="buy-link" (click)="showOverlay(featuredProduct)">{{featuredProduct.prdStatus | translate | uppercase}}</div>
                        <input type="button" class="buy-link" value="{{featuredProduct.prdStatus | translate }}" (click)="showOverlay(featuredProduct)" / -->
                </div>
            </div>

            <div *ngIf="featuredProduct.prdStatus != 'nv_notify_me'" class="compare-remove-container"
                style="padding-bottom: 30px; display: flex; justify-content: space-between;     flex-direction: column;">
                <span kuiText [class.compare]="featuredProduct.addRemoveCompare === 'Compare'"
                    [class.remove]="featuredProduct.addRemoveCompare === 'Remove'" (click)="
                compareProduct(
                  featuredProduct.upc,
                  featuredProduct.addRemoveCompare
                )
              ">{{
                    featuredProduct.addRemoveCompare | lowercase | translate
                    }}</span>
                <a kuiText class="float-right more-info">More Info</a>
                <!-- popover id="207" *ngIf="featuredProduct.hasStsOffer" [screenwidth]="screenWidth" [type]="'Adobe Offer'" [bundle]="featuredProduct.stsOfferTxt"></popover -->
                <popover id="214" *ngIf="
                featuredProduct.hasStsOffer &&
                checkOfferType(featuredProduct.stsOfferTxt, 'a_o')
              " [screenwidth]="screenWidth" [type]="'a_o'"
                    [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'a_o')"></popover>
                <popover id="215" *ngIf="checkOfferType(featuredProduct.stsOfferTxt, 'e_s')" [screenwidth]="screenWidth"
                    [type]="'e_s'" [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'e_s')"></popover>
                <popover id="216" *ngIf="
                featuredProduct.hasStsOffer &&
                checkOfferType(featuredProduct.stsOfferTxt, 'g_b')
              " [screenwidth]="screenWidth" [type]="'g_b'"
                    [bundle]="getOfferTypeText(featuredProduct.stsOfferTxt, 'g_b')"></popover>

                <popover id="218" *ngIf="featuredProduct.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'"
                    [availability]="featuredProduct.shipInfo"></popover>
            </div>
        </div>
    </div>
</div>